module.exports = __webpack_public_path__ + "img/third-left.478fc361.png";